import { render, staticRenderFns } from "./HotBook.vue?vue&type=template&id=075beb58&scoped=true"
import script from "./HotBook.vue?vue&type=script&lang=js"
export * from "./HotBook.vue?vue&type=script&lang=js"
import style0 from "./HotBook.vue?vue&type=style&index=0&id=075beb58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075beb58",
  null
  
)

export default component.exports